import { useTranslation } from 'react-i18next';
import { StepEnablePasskey } from '@/components/biz/fido/step-enable-passkey';
import { StepAllDone } from '@/components/steps/step-all-done';
import { StepVerifyCode } from '@/components/steps/step-verify-code';
import { Flow } from '@/constants/flow';
import { useDisplayAccount } from '@/hooks/use-display-account';
import { useFlowStore } from '@/store/use-flow-store';
import { StepChooseAccount } from './components/step-choose-account';
import { StepDisable } from './components/step-disable';
import { StepDisableRecovery } from './components/step-disable-recovery';
import { StepVerifyPassword } from './components/step-input-password';
import { StepVerifyUserName } from './components/step-input-username';
import { StepRoamGrant } from './components/step-roam-grant';
import { StepSocialAuthorization } from './components/step-social-authorization';
import { StepSocialError } from './components/step-social-error';
import { StepSocialLoginMore } from './components/step-social-login-more';

export const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  const { displayAccount } = useDisplayAccount();
  const { flow } = useFlowStore();

  return (
    <>
      {flow === Flow.LOGIN_STEP_INPUT_USERNAME && <StepVerifyUserName />}
      {flow === Flow.LOGIN_STEP_INPUT_PASSWORD && <StepVerifyPassword />}
      {flow === Flow.LOGIN_STEP_MFA && <StepVerifyCode type="mfa" />}
      {flow === Flow.LOGIN_STEP_ENFORCED_MFA && <StepVerifyCode type="enforced-mfa" />}
      {flow === Flow.LOGIN_STEP_ALL_DONE && <StepAllDone type="login" />}
      {flow === Flow.LOGIN_SOCIAL_LOGIN_MORE && <StepSocialLoginMore />}
      {flow === Flow.LOGIN_STEP_ENABLE_PASSKEY && (
        <StepEnablePasskey title={t('logged_in_as', { userName: displayAccount })} />
      )}
      {flow === Flow.LOGIN_STEP_ROAM_GRANT && <StepRoamGrant />}
      {flow === Flow.LOGIN_STEP_CHOOSE_ACCOUNT && <StepChooseAccount />}
      {flow === Flow.LOGIN_STEP_DISABLE_RECOVERY && <StepDisableRecovery />}
      {flow === Flow.LOGIN_STEP_DISABLE && <StepDisable />}
      {flow === Flow.LOGIN_STEP_SOCIAL_UNAUTHORIZED && <StepSocialAuthorization />}
      {flow === Flow.LOGIN_STEP_SOCIAL_ERROR && <StepSocialError />}
    </>
  );
};

export default LoginPage;
